import { render, staticRenderFns } from "./GLTransactionList.vue?vue&type=template&id=be0f4c12"
import script from "./GLTransactionList.vue?vue&type=script&lang=js"
export * from "./GLTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports